<app-header-analytics
  (days)="manageDays($event)"
  (sites)="manageSites($event)"
  (dates)="manageDates($event)"
  (containers)="manageContainers($event)"
  (arrivalSites)="manageArrivalSites($event)"
  (departureSites)="manageDepartureSites($event)"
  (alertType)="manageAlertTypes($event)"
  (containerCategory)="manageContainerCategories($event)"
  (packaging)="managePackaging($event)"
  (goToLibrary)="showGraphLibraryView()"
  (searchTermChanged)="onSearchTermChanged($event)"
  [hasData]="hasData"
  [graphConfig]="selectedGraphConfig"
  [filterDays]="filterDays"
  [filterSites]="filterSites"
  [filterDateEnd]="filterDateEnd"
  [filterDateStart]="filterDateStart"
  [filterContainers]="filterContainers"
  [filterArrivalSites]="filterArrivalSites"
  [filterDepartureSites]="filterDepartureSites"
  [filterAlertType]="filterAlertType"
  [filterContainerCategory]="filterContainerCategory"
  [filterPackaging]="filterPackaging"
  [filterSitesInput]="filterSitesInput"
  [filterDepartureSitesInput]="filterDepartureSitesInput"
  [filterArrivalSitesInput]="filterArrivalSitesInput"
  [filterPackagingInput]="filterPackagingInput"
  [alertTypesInput]="alertTypesInput"
  [containerCategoriesInput]="containerCategoriesInput"
  [isGraphSelected]="isGraphSelected"
  [showGraphLibrary]="showGraphLibrary"
  [searchTerm]="searchTerm"
></app-header-analytics>
@if (loading) {
  <div class="analytics-title">
    {{ "misc.loading" | translate }}
    <img class="analytics-title-loading" src="/assets/img/spinner-sites.gif" />
  </div>
}
@if ((!filterGraphic || !hasData) && !loading && !hasError) {
  <div class="analytics-title">
    {{
      (!filterGraphic
        ? "analytics.selectGraph"
        : "analytics.selectContainerType"
      ) | translate
    }}
  </div>
}
@if (!hasData && !loading && hasError) {
  <div class="analytics-title">
    {{ errorMsg }}
  </div>
}

@if (showGraphLibrary) {
  <app-graph-library
    (graphSelected)="onGraphSelectedFromLibrary($event)"
    [filteredCharts]="filteredCharts"
    [searchTerm]="searchTerm"
  ></app-graph-library>
}

@if (hasData && !loading && !showGraphLibrary) {
  <app-graphs-displayer
    [datas]="datas"
    [config]="selectedGraphConfig"
    [containerTypes]="filterContainers"
    [filterDays]="filterDays"
    [filterSites]="filterSites"
    [filterArrivalSites]="filterArrivalSites"
    [filterDepartureSites]="filterDepartureSites"
    [filterAlertType]="filterAlertType"
    [filterContainerCategory]="filterContainerCategory"
    [filterPackaging]="filterPackaging"
  ></app-graphs-displayer>
}
